import financialAnalysis from './financialAnalysis';
import financialStatement from './financialStatement';
import cashDividend from './cashDividend';
import consensusAnalysis from './consensusAnalysis';
import ownerShip from './ownerShip';
import snapShot from './snapShot';
import commonFundamental from './common';

export default {
  financialAnalysis,
  financialStatement,
  cashDividend,
  consensusAnalysis,
  ownerShip,
  snapShot,
  commonFundamental,
};
